import type { ThemeOptions } from '@mui/material/styles';

import { colors } from 'src/design-tokens/primitives';

export const focusRing = {
  primary: { default: colors.lime[500], focused: colors.lime[200] },
  secondary: { default: colors.navy[600], focused: colors.navy[200] },
  error: { default: colors.critical[700], focused: colors.critical[100] },
  inherit: colors.gray[300],
};

export const palette: ThemeOptions['palette'] = {
  mode: 'light',
  primary: {
    lighter: colors.lime[100],
    light: colors.lime[400],
    main: colors.lime[700],
    dark: colors.lime[900],
    contrastText: colors.white,
  },
  secondary: {
    lighter: colors.navy[100],
    light: colors.navy[300],
    main: colors.navy[800],
    dark: colors.navy[900],
    contrastText: colors.white,
  },
  error: {
    lighter: colors.critical[50],
    light: colors.critical[300],
    main: colors.critical[600],
    dark: colors.critical[800],
    contrastText: colors.white,
  },
  warning: {
    lighter: colors.amber[100],
    light: colors.amber[400],
    main: colors.amber[700],
    dark: colors.amber[800],
    contrastText: colors.white,
  },
  info: {
    lighter: colors.blue[100],
    light: colors.blue[400],
    main: colors.blue[700],
    dark: colors.blue[800],
    contrastText: colors.white,
  },
  success: {
    lighter: colors.success[100],
    light: colors.success[400],
    main: colors.success[700],
    dark: colors.success[800],
    contrastText: colors.white,
  },
  grey: colors.gray,
  text: {
    primary: colors.gray[800],
    secondary: colors.gray[600],
    disabled: colors.gray[500],
  },
  heading: {
    primary: colors.navy[800],
    secondary: colors.gray[800],
  },
  background: {
    default: colors.gray[100],
    paper: colors.white,
  },
  action: {
    hover: colors.navy[50],
    focus: colors.white,
    selected: colors.navy[100],
    disabled: colors.gray[500],
    disabledBackground: colors.gray[100],
    disabledBorder: colors.gray[200],
  },
  divider: colors.gray[200],
  border: {
    primary: colors.gray[100],
    secondary: colors.gray[200],
    tertiary: colors.navy[200],
  },
  common: {
    white: colors.white,
    black: colors.gray[900],
  },
  focusRing,
  tokens: colors,
};
